import React from 'react'

import { Image } from '@gousto-internal/citrus-react'

import carouselimage from '../assets/carouselimage.jpg'

export const bannerImageSectionAltText =
  'A variety of Gousto recipes from our Quick & Easy, Everyday Favourites, Health Hub, Protein Hit and Global cuisines categories.'

export function BannerImageSection() {
  return (
    <Image
      fit="cover"
      height={['120px', '141px', null, '160px']}
      alt={bannerImageSectionAltText}
      src={carouselimage}
    />
  )
}
